import React, { useContext, useState } from "react";
import Input from "react-phone-number-input/input";
import { InputBaseProps } from "./InputBase";
import { E164Number } from "libphonenumber-js/types";
import { LabelContext } from "../labels/LabelContext";
import { GroupContext } from "../layout/GroupContext";
import classNames from "classnames";
import styles from "./InputBase.scss";

export interface PhoneInputProps
  extends InputBaseProps<E164Number | undefined> {}

/**
 * Input element with the corresponding aria tags.
 */
export const PhoneInput: React.FC<PhoneInputProps> = ({size = 'block',  ...props }) => {
  const [value, setValue] = useState(props.value);

  const onChange = () => {
    if (value != props.value) {
      props.onChange && props.onChange(value);
    }
  };

  const labelCtx = useContext(LabelContext);
  const groupCtx = useContext(GroupContext);

  const state = labelCtx.state || props.state;

  return (
    <Input
      {...props}
      id={props.id || labelCtx.id}
      aria-labelledby={props.describedBy || labelCtx.describedBy}
      className={classNames(styles["au-text-input"], {
        [styles[`au-text-input--${state}`]]: state,
        [styles[`au-text-input--width-${size}`]]: size && size != 'block',
        [styles[`au-text-input--block`]]: size == 'block'
      }, groupCtx.className, props.className)}
      defaultCountry="AU"
      placeholder={props.placeholder}
      value={value? value.toString() : ''}
      onChange={(e) => setValue(e)}
      onBlur={onChange}
      disabled={props.disabled}
      readOnly={props.readonly}
      style={props.rightAlign ? { textAlign: "right" } : {}}
      maxLength={props.maxLength}
    />
  );
};
